<script setup>
import { reactive } from 'vue'
import useAddress from '../../../store/address.store'
import { localeDatePicker } from '../../../utils'
import { useQuasar } from 'quasar'
import { callApi } from '../../../utils'
import { useI18n } from "vue-i18n"
import AddressCreate from './Create.vue'
import { useUrlQuery } from '../../../utils/useUrlQuery'
const { t } = useI18n()

const $q = useQuasar()

const data = reactive({
  startTime: null,
  endTime: null,
})

const { getAddressList, loading, pagination } = useAddress()
const { pushToUrl, clearUrl } = useUrlQuery(data, filter)

function filter () {
  pushToUrl()
  callApi([getAddressList], {
    'page-size': parseInt(pagination.value.rowsPerPage),
    'newer-than': data.startTime,
    'older-than': data.endTime,
  }, $q, loading, true)
}

function reset () {
  console.log("reset")
  data.startTime = null
  data.endTime = null
  clearUrl()
  callApi([getAddressList], { 
    'page-size': parseInt(pagination.value.rowsPerPage) 
  }, $q, loading, true)
}

function create () {
  console.log("create")
  $q.dialog({
    component: AddressCreate
  })
}

</script>

<template lang='pug'>
.address-filter
  q-form(
    @submit='filter'
    @reset='reset'
    class="filter"
  )
    .column
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.startTime'
          :label='t("filter.time.start")'
          mask='####-##-## ##:##:##'
          hide-bottom-space
          hide-hint
        )
          template(v-slot:append)
            q-icon(name='schedule' class='cursor-pointer')
              q-popup-proxy
                div(style='border: 1px solid #ddd; border-radius: 10')
                  q-date(
                    v-model='data.startTime'
                    mask='YYYY-MM-DD HH:mm:ss'
                    minimal
                    :locale='localeDatePicker()'
                  )
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.endTime'
          :label='t("filter.time.end")'
          mask='####-##-## ##:##:##'
          hide-bottom-space
          hide-hint
        )
          template(v-slot:append)
            q-icon(name='schedule' class='cursor-pointer')
              q-popup-proxy
                div(style='border: 1px solid #ddd; border-radius: 10')
                  q-date(
                    v-model='data.endTime'
                    mask='YYYY-MM-DD HH:mm:ss'
                    minimal
                    :locale='localeDatePicker()'
                  )
      .col-auto.q-mb-md
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.clear')"
          :loading='loading'
          type="reset"
          flat
        )
      .col-auto.q-mb-md
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.search')"
          :loading='loading'
          type="submit"
          outline
          size='auto'
          color='primary'
        )
      .col-auto.q-mb-md
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.create')"
          :loading='loading'
          @click='create'
          outline
          size='auto'
          color='primary'
        )
</template>